const KEYWORDS = [
  'Affordability',
  'Tuition',
  'Program length',
  'Passion',
  'Helping others',
  'Career goals',
  'Salary potential',
  'Accredited',
  'Accreditation',
  'License',
  'Licensure',
  'Faculty credentials',
  'Research',
  'Clinical experience',
  'Clinical opportunities',
  'Internships',
  'Internship rates',
  'Licensure rates',
  'nonprofit',
  'not-for-profit',
  'no GRE scores',
  'no GRE scores required',
  'no GRE required',
  'CSWE Accredited',
  'CSWE',
  'certified school counselors',
  'certification',
  'clinical training',
  'board certified',
  'career development',
  'No SAT or ACT scores required',
  'future counselors',
  'innovative research',
  'advance your human services career',
  'psychological research',
  'set you apart from the competition',
  '100% online program',
  'wide variety of career paths',
  'effect positive change',
  'five specialized tracks',
  'top ranked for return on investment',
  'earn higher salaries',
  'work as certified school counselors',
  'real-world training',
  'interactive online classes',
  "fit your state's requirements",
  'interdisciplinary curriculum',
  'board certified',
  '60 credit hour',
  'foundation in psychological domains',
  'specialized knowledge',
  'prepare you for a career',
  'advanced doctoral training',
  'board certified behavior analyst',
  '18-month online MA in Psychology',
  'helps prepare you to work',
  'optional internship',
  'apply classroom studies to real-world situations',
  'meets the Guidelines for Education and Training',
  'one of the oldest and best of its kind',
  "specialized online bachelor's",
  'expand your expertise',
  'National Certified Addiction Counselor (NCAC)',
  'emphasis in Clinical Counseling',
  'real-world field experience',
  'two to four years',
  'flexible online format',
  'field experience',
  'advance your career',
  'solve social problems',
  'without disrupting their professional lives and other commitments',
  'improves health and wellness',
  'diverse career paths',
  'dual credit opportunity',
  'strong foundation',
  'No SAT or ACT scores required',
  'build expert skills',
  'apply psychological research and theory',
  'virtual classroom',
  'make a positive impact',
  'hands-on experiences',
  'passion to help people',
  'industry-current',
  'American Psychological Association',
  '100% online',
  'transfer up to 90 previous credit hours',
  'prepare for graduate studies',
  'transform lives',
  'Christian worldview',
  'critical and creative thinking',
  'mental health concentration',
  'wide range of professional applications',
  'flexibility and convenience',
  'pursue a career',
  'improve health and wellness',
  'passion to help people',
  'two applied concentration tracks',
  'interdisciplinary degree',
  'prevent marginalization and improve equality',
  'overcome health and wellness challenges',
  'connections between human behavior and organizational performance',
  'ideal fit for busy professionals',
  '15 months',
  'direct path to certification',
  'Board Certified Behavior Analyst',
  '12 months',
  'Board Certified Behavior Analyst (BCBA)',
  'improve their lives',
  'BSBA',
  'Build a well-rounded foundation',
  "support society's most vulnerable populations",
  'designed for students seeking a flexible option',
  'flexible',
  'online degree program',
  'pursue licensure',
  'seek employment',
  'Licensed Mental Health Counselor',
  'in as short as 2 years',
  'Channel your passion',
  'best for your schedule',
  'small cohort model',
  'experienced faculty',
  'helping people face addiction',
  'top-15 school',
  'GRE scores are not required',
  'as few as 24 months',
  'No GRE is required',
  'prepare you to work in therapeutic settings',
  'recognized both nationally and internationally',
  'broaden and deepen their knowledge behavioral health administration and care',
  'Eighteen (18) credit hours',
  'prepare you to assume leadership positions',
  'become a visionary leader',
  'online coursework',
  'offline practicum',
  'as few as 32 months',
  'impact higher education',
  'helping young learners succeed',
  'assessing learning abilities and needs',
  'wide variety of potential career pathways',
  'examine psychology from various aspects',
  'pursue an impactful career',
  'broad-based education',
  'as little as one year',
  'interdisciplinary business skills',
  'leadership & management skills',
  'Financial aid is available',
  'no-cost digital materials',
  'managerial expertise',
  'ACBSP-accredited',
  'eight concentrations',
  'earn skills',
  'fully online',
  'prepare yourself for a path to graduate school',
  'technical knowledge',
  'critical thinking skills',
  'business administration skills',
  'problem solving and communication',
  'ACBSP',
  'define your competitive edge',
  'career-focused concentrations',
  'based on sound business fundamentals',
  'hundreds of adult students',
  'advance their careers',
  'International Business',
  'grow and thrive as a leader',
  'build administrative skills',
  'advancing your degree',
  'mobile-friendly curriculum',
  'business fundamentals',
  'emphasis on ethical leadership',
  'industry-focused concentration',
  'professional success',
  'top faculty',
  'convenient online classroom',
  'on your schedule',
  'tuition-free',
  'variety of industries and organizations',
  'seeking a managerial role',
  'ethical leader',
  'small class',
  'responsive faculty',
  'transfer credit policies',
  'seamlessly switch from online study to in-person learning',
  'effective teamwork',
  'motivate people',
  'master your decision-making and problem-solving skills',
  'ensure long-term sustainability',
  'concentration in entrepreneurship',
  'online classroom',
  'complete your degree at your pace',
  'Learn how to start and run your own business',
  'work one-on-one with an entrepreneur',
  'excel in the world of finance',
  'as few as 2.5 years',
  'No residencies or standardized test scores (SAT/ACT) required.',
  'Advance a service or manufacturing operations management career',
  'use your skills in the business field',
  'Develop technical skills and accounting knowledge',
  'accounting careers in all industries',
  'Demand for accounting graduates continues to be strong',
  'even during economic downturns',
  'Accountants are vital',
  'entirely online',
  'prepare for the CPA exam',
  'effective accounting professional',
  'as few as 16 months',
  'business analyst',
  'financial planner',
  'actuary',
  'apply practical accounting principles',
  'foundational knowledge of tax planning',
  'affordable',
  'succeed in the information industry',
  'build a repository of skills',
  'develop knowledge and skills in computer-based systems',
  'Prepare for leadership roles in information system management',
  'strategically manage and utilize technology',
  'management accounting',
  "specialized bachelor's degree",
  'management-level role',
  '12 optional concentrations/built-in certificates',
  'lead your teams with confidence',
  'No GRE/GMAT required',
  'Flexibly designed for full-time professionals',
  'top-ranked MBA degree',
  'just 16 months',
  '$21K',
  'No GMAT required',
  'earn two credentials for less time and money',
  'part-time program',
  'individualized career services',
  'largest conferrer of MBAs in the state',
  'gives students the ultimate flexibility',
  'designed for busy professionals',
  'personalized instruction from experienced experts',
  '45 credit hours',
  'specialized expertise',
  'AACSB-accredited',
  'tailor your degree',
  'full suite of career services',
  'as few as two and a half years',
  'achieve your goals',
  'designed for working professionals',
  'maximum flexibility',
  'specialize your skills',
  'as little as two years',
  'flexibility',
  'IACBE-accredited',
  'aligns with the Forbes brand',
  'fits both your professional and personal life',
  'accelerated 1 year MBA program',
  'no GRE/GMAT required',
  'No application fee required',
  'dual degree',
  'part-time program',
  'total of 30 hours',
  'lead in the modern workplace',
  'CCNE-accredited',
  'provide holistic health care',
  'greater flexibility',
  'personal fulfillment',
  'higher salary',
  'increased opportunities',
  'Designed for working nurses',
  '100% online coursework',
  'clinical placement support',
  'ideal option for practicing nurses',
  "Designed for graduates of a bachelor's degree program",
  '100% online didactic classes',
  'flexible scheduling',
  "Earn two master's degrees",
  'maintain flexibility',
  'valuable nursing credential',
  'multiple concentrations',
  'Flexible 12- or 24-month track',
  'No GRE required',
  'An internship and capstone experience are required',
  'improve healthcare',
  'senior management roles in health care',
  'gives students ultimate flexibility',
  'online CSWE-accredited',
  'flexibility of online learning',
  'real-world skills',
  'supervised field experience',
  '3.0 GPA or better',
  'Advanced Standing option',
  'faster and at a lower overall cost',
  'accredited by the Council on Social Work Education (CSWE)',
  'CSWE accredited',
  'strong liberal arts base',
  'diverse populations',
  "bachelor's in human services",
  'flexible online courses',
  '100% Online',
  '120 credit hours',
  'highly-ranked',
  'CSWE-accredited',
  'Comprehensive curriculum',
  'field experience hours',
  'Pending accreditation by the Council on Social Work Education (CSWE)',
  'social services',
  'alleviate poverty and oppression',
  'generalist practice',
  'graduate in 2-4 years',
  'political and cultural change',
  'organizational dynamics',
  'eligible to sit for the LBSW exam',
  'optional concentrations',
  'notable faculty',
  'advocacy',
  'problem-solving',
  'consultation',
  '15 months',
  'four specialized courses of study',
  'Individualized Course of Study',
  'Online MSW program',
  'local field education',
  'pursue licensure',
  'including LCSW',
  'Accredited by the CSWE',
  'No GRE scores required',
  'Full-time',
  'part-time',
  'and accelerated tracks top-ranked school of social work',
  'two online MSW tracks',
  'traditional and advanced standing',
  'earn an MSW in as few as 18 months',
  'GRE scores are not required',
  'concentration in Mental Health and Trauma',
  'advanced standing program track knowledge and skills',
  'diverse funding sources',
  'influence policy',
  'supervise staff',
  'develop and administer programs competencies from the Council on Social Work Education (CSWE)',
  'Foundational Track',
  'Advanced Standing Track',
  'experiential learning opportunities',
  'clinical and non-clinical settings',
  'child welfare agencies',
  'non-profit agencies',
  'medical facilities',
  'correctional settings 100% Online',
  '3 starts a year',
  'highly-ranked',
  'CSWE-accredited',
  'social justice',
  'stronger communities unique skills',
  'significant difference',
  'values of the Sisters of Mercy',
  'sit for licensure',
  'professional social worker online Master of Social Work (MSW)',
  'clinical social work',
  'licensure exams',
  'innovative solutions',
  'complex mental health and social issues affordable',
  'CSWE-accredited',
  'expert faculty',
  'hands-on field work',
  'licensed social worker clinical social work',
  'change agents',
  'Clinical Advocacy focus',
  'community resources',
  "accredited by the Council on Social Work Education's (CSWE) Board of Accreditation (BOA)",
  'CSWE competencies social work leader',
  'and global issues',
  'mental health',
  'substance abuse',
  'child and youth services',
  'accelerated',
  'one-year program generalist clinical social work practice',
  'CSWE accredited',
  'five specializations',
  'MBA or MPA dual degree options 100% online',
  'CSWE accredited',
  'No GRE required',
  'positive change',
  'leadership and effective collaboration',
  'specialization in integrative social work',
  'five specialized tracks',
  'accredited by the Council on Social Work Education (CSWE) licensure in Missouri or select Midwestern states',
  'meaningful impact on society trauma-informed curriculum',
  'culturally informed assessment',
  'advance justice and social change',
  'flexibility',
  'prepare for licensure Diverse Group of Faculty & Students',
  'Accessible and Rigorous MSW Degree',
  "nation's best Online MSW Programs",
  'no GRE/GMAT required 100% Online',
  '60 credit hours',
  'career preparation',
  'professional growth',
  'counseling modalities',
  'essential policy knowledge',
  'ethical practitioner',
  'advocate for social change',
  'online RN to BSN program',
  'Applicants must already hold an RN',
  'seamlessly take classes',
  'complete in-person requirements',
  'without disrupting professional responsibilities',
  'pre-licensure bachelor degree in nursing',
  'evidence-based client/patient care',
  'liberal arts education core',
  'clinical judgment',
  'critical thinking skills',
  'diverse populations',
  'lifelong learning',
  'integrated throughout the curriculum',
  'theoretical instruction',
  'clinical experience',
  '24.00 semester credit hours of block credit',
  'nursing leadership and management',
  'quality improvement',
  'patient safety',
  'promote health and prevent disease',
  'lifelong learning',
  'continuous professional development',
  'critical thinking',
  'conceptual level',
  'mathematical analysis',
  'scientific method',
  'Bachelor of Science in Nursing',
  'broader professional responsibilities',
  'career opportunities',
  'online Bachelor of Science in Nursing completion program',
  'specialized nursing',
  'nursing management',
  'critical thinking skills',
  'clinical judgment',
  'accredited by the Commission on Collegiate Nursing Education',
  'Bachelor of Science in Nursing',
  'broader professional responsibilities',
  'career opportunities',
  'online Bachelor of Science in Nursing completion program',
  'specialized nursing',
  'nursing management',
  'critical thinking skills',
  'clinical judgment',
  'accredited by the Commission on Collegiate Nursing Education',
  '1 year',
  'online RN to BSN program',
  'real-life situations',
  'evidence-based practice',
  '100% Online',
  '8 week terms',
  'Up to 30 credits tuition-free',
  'ADN required',
  'Mercy principles and ethics',
  'CCNE-accredited RN-BSN degree',
  'leaders in their chosen specialty areas',
  'Graduate in just 11 months',
  'CCNE-accredited online RN to BSN',
  '100% online coursework',
  'complete in as little as one year',
  'dedicated faculty',
  'real-world curriculum',
  'fast and flexible online RN to BSN',
  'completed in 14 months',
  'CCNE-accredited',
  'no in-person practicum',
  'up to 95 transfer credits',
  'highly regarded faculty',
  '100% online Bachelor of Science in Nursing',
  'full-time working adult student',
  'Transfer up to 90 credits',
  'ASN',
  'active unencumbered RN licensure',
  'top-ranked',
  'advance your health care career',
  'foundation for further graduate studies',
  'critical thinking',
  'practice skills',
  'clinical management',
  'constantly changing health care environment',
  'BSN online',
  'accredited by the Arizona State Board of Nursing',
  'Commission on Collegiate Nursing Education',
  'notable faculty',
  'expand nursing competencies',
  'regionally accredited',
  'adult learner RN',
  'experts in their respective fields',
  'clinical patient care',
  'health care management',
  'professional nursing practice and leadership',
  'nurse competencies',
  'management and leadership',
  'health assessment',
  'statistics',
  'research',
  'ethical decision-making',
  'public health',
  'spirituality in health care',
  'effective leaders in the nursing profession',
  'preparation in many areas',
  'criminal justice system',
  'investigation',
  'prosecution',
  'Supreme Court',
  'Constitution',
  'degree completion program',
  'transfer a large number of college credits',
  'core and elective Criminal Justice courses',
  'law enforcement',
  'surveillance',
  'homeland security',
  'social service',
  'criminal justice degree',
  'Online coursework',
  'criminal law',
  'ethics',
  'research methods',
  'solid foundation in criminal justice',
  'broad liberal arts education',
  'faculty with years of experience',
  'crime scene investigation',
  'forensic psychology',
  'homeland security',
  'juvenile justice',
  'law enforcement',
  'earn credit for eligible prior learning',
  'new career opportunities',
  'solid foundation in criminal justice',
  'broad liberal arts education',
  'faculty with years of experience',
  'crime scene investigation',
  'forensic psychology',
  'homeland security',
  'juvenile justice',
  'law enforcement',
  'earn credit for eligible prior learning',
  'new career opportunities',
  'change lives',
  'enhance communities',
  'fair and just treatment',
  'expertise in criminality and procedure',
  '100% Online',
  'transfer in your associate degree',
  '60 credit hours',
  '20 courses',
  'working knowledge',
  'justice process',
  'enhance your knowledge',
  'criminal justice',
  'law enforcement',
  'crime prevention',
  'interagency collaboration',
  'real-world issues',
  'accredited state university',
  'enhance your knowledge',
  'criminal justice',
  'law enforcement',
  'crime prevention',
  'interagency collaboration',
  'real-world issues',
  'accredited state university',
  'start or advance your career',
  'law enforcement',
  'online BS in Criminal Justice',
  'pure academics',
  'seasoned practitioners',
  'online B.S. in criminal justice administration',
  'entry-level and seasoned professionals',
  'rational decisions',
  'informed responses',
  'law enforcement',
  'courts and corrections',
  'online Bachelor of Arts in Criminal Justice Policy',
  'five start dates per year',
  'fully digital format',
  'complete within 2 years',
  'advance your career',
  'solid foundation',
  'theoretical knowledge',
  'practical application',
  'juvenile justice',
  'law enforcement',
  'homeland security',
  'governmental positions',
  'online B.S. in Criminal Justice',
  'flexible online program',
  'real-world social and criminal justice issues',
  'transfer up to 75 credits',
  'degree completion program',
  'fully online BA',
  'real-life experiences',
  'national security',
  'local/state/federal law enforcement',
  'investigate a rewarding career',
  'Bachelor of Science in Criminal Justice Administration',
  'law enforcement careers',
  'private security employment',
  'administration of justice',
  'foundational insights and theories',
  'opportunities within the field of criminal justice',
  'flexible',
  'customizable',
  'online program',
  'policing',
  'critical thinking',
  'resilience',
  'cultural engagement',
  'personalized support services',
  'vibrant online community',
  'BS in criminology and criminal justice - policing',
  'notable faculty',
  'policing strategies',
  'reducing crime',
  'criminal justice principles',
  'practice orientation',
  'global perspective',
  'specialty coursework',
  'law enforcement',
  'criminal courts',
  'corrections',
  '36 credit hour program',
  'entirely online',
  'CPA certification',
  'career in accountancy',
  'complete the program in 12 months',
  'industry leaders in accounting',
  'strategic overview',
  'competitive advantage',
  'all course materials included',
  'laptop computer',
  'first course FREE of charge',
  'course credit for professional training/certifications',
  "Master's in Accounting",
  'Certified Public Accountant (CPA)',
  'corporate accountant',
  'auditor',
  'financial analyst',
  'high-level positions',
  'banking',
  'taxation',
  'insurance',
  'financial division',
  'unique competitive advantage',
  'enhanced analytical skills',
  'latest technology',
  'financial analysis methods',
  'no GMAT or GRE required',
  'online or on campus',
  'concentrations in Auditing',
  'Forensics Accounting',
  'Taxation',
  'accounting leadership',
  'online Master of Science in Accounting',
  'Certified Public Accountant (CPA) partners',
  'Chief Financial Officers (CFO)',
  'communication',
  'ethical leadership',
  'strategic management',
  'critical thinking',
  'problem-solving skills',
  'mid- to senior-level positions',
  'auditing',
  'cost accounting',
  'financial accounting',
  'elective courses',
  'certification examinations',
  'Certified Internal Auditor (CIA)',
  'Certified Management Accountant (CMA)',
  'concentrations: audit',
  'finance',
  'government',
  'tax',
  'ACBSP accredited',
  'solid MBA',
  'accounting expertise',
  'online coursework',
  'no GRE/GMAT required',
  'Master of Accountancy',
  'apply principles of accounting',
  'solve real-world problems',
  'graduate degree specialization',
  'three courses',
  'nine credits',
  'greater responsibilities',
  'accounting role',
  'transition into accounting',
  'CPA credential',
  'high-quality educational experience',
  'tailored to working professionals',
  'career-focused skills',
  "master's degree in management",
  'focus in accounting',
  'mid-career professionals',
  'comptroller',
  'managing partner',
  'senior accountant',
  'Master of Business Administration',
  'emphasis in Accounting',
  'advanced management positions',
  'corporate or public accounting',
  'financial accounting and reporting',
  'regulation',
  'specialized accounting topics',
  'organizational decision making',
  'transformational leadership',
  'interpersonal skills',
  'diverse cultures',
  'critical thinkers',
  'decision makers',
  'accelerated evening or online',
  'Master of Science in Accounting (MSA)',
  "Certified Public Accountant's credentials",
  'Uniform CPA Exam',
  'two capstone courses',
  "bachelor's degree in accounting",
  'bridge program',
  'teacher licensure',
  'early childhood',
  'Interstate Teaching Assessment and Support Consortium (InTASC)',
  'National Association for the Education of Young Children (NAEYC)',
  'common core standards',
  'child development',
  'cultural diversity',
  'verified field experiences',
  'student teaching',
  'educational theory',
  'experiential learning opportunities',
  'effective teachers',
  'public and private elementary schools',
  'Christian worldview',
  'diverse learner needs',
  'servant-leadership',
  'small class sizes',
  'individualized learning',
  'direct access to professors',
  'early childhood development',
  'leader in the early childhood field',
  'operating or owning their own early childhood program',
  'managing an early childhood agency or organization',
  "online bachelor's degree",
  'ranked No.1 in Oregon',
  'non-licensure degree program',
  'teaching advancement',
  'policy-making',
  'hybrid BA in Early Childhood Education',
  'mainly online coursework',
  'fieldwork',
  'two practicums',
  'Curriculum Alignment Project Eight (CAP 8)',
  'strategies for resilience',
  'crisis and trauma',
  'educational career paths',
  'ECE experience',
  'train educators and administrators',
  'preschool to early elementary',
  'safe',
  'dynamic',
  'and compassionate settings',
  'BAE in educational studies - early childhood studies',
  'care of children from birth to age five',
  'school readiness',
  'future educational success',
  'initial teacher licensure',
  'early childhood education programs',
  'universal preschool education',
  'expertise in early childhood',
  'instructional strategies',
  'teaching methodologies',
  'assessment techniques',
  'theories of early childhood growth',
  'embedded practicum experiences',
  'student teaching component',
  'teaching credential in Arizona',
  'internship experiences in a K-3 classroom',
  'motivate',
  'develop and educate children from birth to Grade 3',
  'real estate market rebounds',
  'career opportunities',
  'right skills and training',
  'foundations of real estate',
  'sales',
  'market analysis',
  'finance',
  'ethics',
  'law',
  'national real estate or broker license exams',
  'online pathway',
  'Bachelor of Science in Nursing (BSN)',
  'minimum GPA requirement',
  'nursing education',
  'earn an associate degree',
  'qualify for entry',
  'pre-licensure BSN program',
  'general education classes',
  'associate degree',
  'career flexibility',
  'Associate of Science degree',
  'Medical Administrative Billing and Coding',
  'accurate medical codes',
  'diagnostic procedures',
  'clerical and administrative functions',
  'insurance claims',
  'compliance',
  'reimbursement',
  'specialization in information assurance',
  'programming',
  'computer forensics',
  'information security',
  'artificial intelligence',
  'computer science capstone experience',
  'Bachelor of Science in Computer Science (BSCS)',
  'strong academic foundation',
  'design and implementation projects',
  'ABET-accredited',
  'employment in the computer industry',
  'implement software-based solutions',
  'computer science professionals',
  'dynamic BS in Computer Science',
  'hands-on curriculum',
  'technical challenges',
  'societal and ethical responsibilities',
  'BS in computer science online',
  'renowned faculty',
  'specific training',
  'career goals',
  'operating environments',
  'testing platforms',
  'computer systems analysts',
  'applications and software developers',
  'B.S. in Computer Science',
  'analyze problems',
  'design solutions',
  'interpersonal skills',
  'accredited state university',
  'computer systems',
  'software engineering principles',
  'analytics',
  'emerging technology',
  'AI',
  'Cisco',
  'wireless networking',
  'cloud computing',
  'network administration',
  'network technology',
  'career-ready skills',
  'cutting-edge computer applications',
  'Association for Computing Machinery (ACM) guidelines',
  'computer programming',
  'coding',
  'software development',
  'data analysis',
  'technical skills',
  'fast-paced field',
  'new types of technology',
  'innovative computer solutions',
  'Associate of Science online degree',
  'Medical Assisting',
  'preparing examination rooms',
  'taking vital signs',
  'minor surgical procedures',
  'giving injections',
  'performing venipuncture',
  'laboratory operations',
  'taking x-rays',
  'administering electrocardiograms',
  'administrative capacity',
  'patient communications',
  'maintaining patient records',
  'scheduling appointments',
  'processing insurance claims',
  'practical clinical experience',
  'Registered Medical Assistant',
  'hands-on patient care',
  'taking blood pressure',
  'drawing blood',
  'medical history',
  'administrative and clerical duties',
  'scheduling appointments',
  'concentrations health information management',
  'patient safety and quality',
  'aligned with AUPHA',
  'solid foundation',
  'core disciplines',
  'health care administration and management',
  'supervisory roles',
  'day-to-day operations',
  'earn college credit',
  'up to 48 credit hours tuition free',
  '100% online',
  'flex or term enrollment options',
  'administrative leadership roles',
  'business principles',
  'ethics of professional standards',
  'leadership styles',
  'AUPHA-certified',
  'rigorous curriculum',
  'internship opportunity',
  'competitive edge',
  'experienced faculty',
  'leadership skills',
  'healthcare knowledge',
  'Christian worldview',
  'ethical considerations',
  'quality of life issues',
  'Christian values',
  'real-world skills',
  'career-boosting connections',
  'career change',
  'career advancement',
  'communication',
  'management',
  'expert faculty',
  'business mindset',
  'passion for helping others',
  'hands-on experience',
  'internship',
  'coordinate medical and health services',
  'maintain patient records',
  'healthcare laws',
  'manage teams',
  'leadership and practical management skills',
  'diverse healthcare settings',
  'ACBSP-accredited',
  'specialized skills',
  'oversee operations',
  'healthcare ethics',
  'health information systems',
  'health services manager',
  'health information manager',
  'records manager',
  'policies & procedures',
  'U.S. health care system',
  'administrative roles',
  'entry-level supervisory roles',
  'health care organizations',
  'career entry',
  'advance from clinical or technical roles',
  'conceptual and analytical skills',
  'contemporary health care organizations',
  "master's degree",
  'senior health care executive positions',
  'project management',
  'in-depth understanding',
  'strategic management',
  'decision-making',
  'human resources',
  'information management',
  'quality improvement',
  'public policy',
  'administrative positions',
  'long-term care',
  'outpatient facilities',
  'physician offices',
  'mental health organizations',
  'insurance companies',
  'public health agencies',
  'framework of general education courses',
  'foundational knowledge',
  'challenging health industry',
  'legal and ethical parameters',
  'risk and quality management',
  'expand professional opportunities',
  'aligned to the Society of Human Resource Management (SHRM)',
  'management-level positions',
  'advanced human resource management skills',
  'communication and negotiation skills',
  'legal and ethical principles',
  'strategic HR program development',
  'global and cultural context',
  'no GMAT/GREs',
  'fully online',
  'MBA - Human Resource Management',
  'private industry and public sector',
  'organizational performance and productivity',
  '36-hour',
  'accelerated online program',
  'completed in 12 months',
  'practical application',
  'practitioner-scholars',
  'executive-level experience',
  'all course materials included',
  'laptop computer',
  'first course FREE of charge',
  'course credit for professional training/certifications',
  'key organizational role',
  'curriculum aligned with SHRM',
  'up-to-date expertise',
  '100% Online',
  '8 week terms',
  '5 starts per year',
  'knowledge and skills',
  'SHRM-aligned curriculum',
  'ultimate flexibility',
  'personalized instruction',
  'SHRM certified',
  'national SHRM exam',
  '100% online',
  'flexible 12- or 24-month track',
  'no GRE required',
  'strategic role',
  'HR leaders',
  'maximize employee engagement',
  'cultural',
  'regulatory',
  'and behavioral issues',
  'strategic partner',
  'workforce capabilities',
  'problem-solving',
  'data-driven decision-making',
  'strategic management skills',
  'competitive in a global marketplace',
  'strategic partner',
  'HR management',
  'evaluation and analysis',
  'interpersonal competencies',
  'critical thinking',
  'ethical reasoning',
  'globally connected and diverse world',
  'strategic partner',
  'HR management',
  'corporate',
  'nonprofit',
  'municipal organizations',
  'evaluation and analysis',
  'complex HR laws',
  'interpersonal competencies',
  'critical thinking',
  'ethical reasoning',
  'successful HR manager',
  'globally connected and diverse world',
  'Master of Business Administration',
  'Emphasis in Strategic Human Resource Management',
  "Society for Human Resource Management's critical competencies",
  'human resource competencies',
  'senior human resources specialists',
  'general managers',
  'strategic HR acumen',
  'human resources concentration',
  'employment practices',
  'personnel administration',
  'employee training',
  "aligns with SHRM's HR Curriculum Guidebook",
  'human resources expertise',
  "improve your company's culture",
  'SHRM & HRCI',
  'prepare for PHR',
  'SPHR',
  'SHRM-CP exams',
  'leadership and management skills',
  'human resources',
  "bachelor's degree in business management",
  'Human Resource Management specialization',
  'transfer credits',
  'human resource manager',
  'specialist',
  'consultant',
  'business economics',
  'strategic human resources planning',
  'technology management',
  'transfer up to 90 approved credits',
  'library and writing center',
  'broad knowledge',
  'managing human resources',
  'recruitment',
  'selection',
  'retention',
  'compensation and benefits',
  'training and talent development',
  'legal compliance',
  'diversity',
  'equity',
  'inclusion',
  'Human Resource Management degree program',
  'HR functional areas',
  'employee development',
  'employment law',
  'compensation and benefits',
  'core HR systems',
  'principles of management',
  'SHRM Certification Prep',
  'Labor & Management Relations',
  'Managerial Accounting',
  'Bachelor of Arts in Organizational Leadership',
  'globally competitive environment',
  'critical thinking',
  'collaborative',
  'strategic leadership skills',
  'open minded',
  'creative solutions',
  'leading with integrity',
  'leadership development',
  'analytical thinking',
  'collaborative relationships',
  'BA in business - human resources online',
  'current & relevant curriculum',
  'notable faculty',
  'rewarding employees',
  'financial and analytical knowledge',
  "bachelor's degree",
  'accredited state university',
  'prepare for CMA and CFP exams',
  'financial expertise',
  'online Bachelor of Science in business administration',
  'concentration in finance',
  'leadership skills',
  'manage funds',
  'loss prevention managers',
  'management analysts',
  'investment fund managers',
  'financial planning degree',
  'four-year undergraduate degree',
  'evaluating risk',
  'investments',
  'taxes',
  'diversification',
  'ethics',
  'financial advisor roles',
  'financial managers',
  'financial health',
  'practical and theoretical training',
  'financial decision-making',
  'creation of wealth',
  'managing financial resources',
  'Bachelor of Business Administration in Finance',
  '100% online study',
  'certified financial planner',
  'in-demand roles',
  'six start dates per year',
  'IACBE-accredited',
  'Bachelor of Arts in Finance',
  'long-range financial planning',
  'efficient use of financial resources',
  'Bachelor of Science in Finance',
  'online',
  '8-week accelerated modules',
  'Corporate Finance',
  'Personal Finance',
  'management accounting',
  "specialized bachelor's degree",
  'Accounting Information Systems',
  'Controllership',
  'Financial Statement Analysis/Business Valuation',
  'Data Analytics for Financial Professionals',
  'BA in business - financial planning',
  'portfolio',
  'tax',
  'insurance',
  'estate management',
  'problem-solving',
  'data analysis strategies',
  "online business administration bachelor's degree",
  'government organization',
  'technical knowledge',
  'critical-thinking skills',
  'corporate finance',
  'banking',
  'real estate',
  'financial markets',
  'investment management',
  'wealth management',
  'accelerated Master of Science in Finance (MSF)',
  'portfolio manager',
  'financial analyst',
  'online associate degree in accounting',
  'foundation in accounting principles',
  'cost accounting',
  'taxation',
  'business law',
  'Associate of Applied Science in Accounting',
  'knowledge of accounting theories',
  'communicate effectively',
  'network with people',
  'entry-level opportunities',
  'ACBSP accredited',
  'teaching excellence',
  'continuous quality improvement',
  'online Associate of Science in Accounting',
  'traditional accounting jobs',
  'practice-based environment',
  'public accounting',
  'corporate income taxation',
  'accounting information systems',
  'auditing',
  'law enforcement',
  'education',
  'online Master of Health Administration',
  "earn your master's degree in as few as 24 months",
  'health care leader',
  "Bachelor's degree required",
  'No GRE/GMAT scores required',
  'Master of Science in Healthcare Administration',
  'advanced healthcare education',
  'AUPHA',
  'CAHME',
  'HLA',
  'key business and leadership skills',
  'accredited by NEASC',
  'CCNE',
  'ACBSP',
  'no GMAT or GRE required',
  'earn your degree in as few as 15 months',
  '2 courses per term',
  'radical changes',
  'medical and health services managers',
  'complex new developments',
  'leadership and management positions',
  'nonprofit',
  'private organizations',
  'MBA in Healthcare Administration',
  '36 credit hour program',
  'entirely online',
  'complete the program in 12 months',
  'executive-level business principles',
  'all course materials included',
  'first course FREE of charge',
  'course credit for professional training/certifications',
  'accredited degree programs',
  'collaborative learning',
  'industry insights',
  'professional network',
  'healthcare leaders',
  "master's in healthcare administration",
  'and manage healthcare operations',
  '100 percent online coursework',
  'innovative',
  'strategic business skills',
  'healthcare industry',
  'rising costs',
  'aging population',
  'projected 30+ percent growth',
  'advance your healthcare career',
  "master's degree in health care administration online",
  'Master of Health Administration',
  'complex healthcare industry',
  'real-world experiences',
  'high-impact management roles',
  'Master of Science in Health Care Administration',
  'improve quality and efficiency',
  'control costs',
  'innovative change agents',
  'organizational improvement',
  'conceptual',
  'analytical',
  'and application skills',
  'health sciences',
  'contemporary health care',
  'hospitals',
  'long-term care facilities',
  'outpatient facilities',
  'physician offices',
  'mental health agencies',
  'insurance companies',
  'public health agencies',
  'Master of Health Administration (MHA)',
  'dynamic and ever-changing health care industry',
  'critically examine and evaluate',
  'global health care system',
  'quality improvement',
  'strategic planning',
  'specialization options',
  'gerontology',
  'informatics',
  'management/administrative background',
  'BSN to MSN-NP tracks',
  'Psychiatric Mental Health NP',
  'Pediatric NP',
  'Family NP',
  'Adult-Gerontology Primary Care NP',
  'MSN Nurse Educator',
  'MSN/MBA dual degree programs',
  "master's degree in nursing",
  'accredited by the Commission on Collegiate Nursing Education',
  'study online',
  'career advancement',
  'faculty',
  'staff development roles',
  'practicum',
  'clinical practice experience',
  'executive leader',
  'nurse educator',
  'adult-gerontology primary care nurse practitioner',
  'family nurse practitioner',
  'Nursing@Simmons',
  'aspiring FNPs',
  'MSN online',
  'board pass rate',
  'clinical placements',
  'RN required',
  'Family Nurse Practitioner Program',
  'health and well being',
  'cutting-edge science',
  'primary care settings',
  'holistic approach',
  'RN to MSN program',
  'Family Nurse Practitioner',
  'clinical practice',
  'online',
  'flexible pacing',
  'on-campus immersion',
  'mentored practicum',
  '$7.5k MSN-FNP grant',
  'CCNE-accredited Nursing MS degree',
  'nursing leadership',
  'nursing education',
  'family nurse practitioner',
  'research-backed curriculum',
  'expert faculty',
  'practicums',
  'leadership abilities',
  'CCNE-accredited online MSN',
  'leadership position',
  'comprehensive online coursework',
  'practical experience',
  'MSN - MBA dual degree',
  'low-residency program',
  'leadership and education',
  'business expertise',
  'leadership positions',
  'healthcare nursing education',
  'management',
  'healthcare administration',
  'health care quality and patient safety',
  'Master of Science in Nursing',
  'quality improvement measures',
  'clinical decision-making',
  'patient safety',
  'CCNE accredited',
  'complete in 2.3 years',
  'online MSN - Adult-Gerontology Primary Care Nurse Practitioner',
  'treat adolescents through to older adult patients',
  'innovative approach',
  'devoted faculty',
  'Master of Science in Nursing',
  'accredited by the Commission on Collegiate Nursing Education',
  'enhance knowledge and skills',
  'leadership roles',
  'practice and educational settings',
  'advanced nursing content',
  'leadership skills',
  'Masters in Corporate Finance Concentration',
  'career opportunities',
  'corporate finance jobs',
  'finance and corporate finance courses',
  'managerial accounting',
  'capital budgeting',
  'fiscal and monetary policies',
  '36-credit-hour',
  'Investments and Securities',
  'MS in Finance',
  'online or on campus',
  'financial analysis',
  'quantitative skills',
  'leader in the field',
  'Ranked #2 in the nation',
  "Georgetown's MSF",
  'rising industry leaders',
  'McDonough School of Business',
  'world-class curriculum',
  'online learning platform',
  'Master of Science in Finance',
  'maximize your career potential',
  'firsthand industry knowledge',
  'financial analysis',
  'financial planning',
  'knowledge and skills',
  'MBA@UNC',
  'quality and flexibility',
  'top-ranked UNC Kenan-Flagler',
  'innovative technologies',
  'real-world immersion',
  'interactive communication',
  'global immersions',
  'financial operations expertise',
  'executive-level skills',
  'UMGC',
  'accredited state university',
  'IIA recognized IAEP program school',
  'financial operations expertise',
  'in-demand executive-level skills',
  'UMGC',
  'accredited state university',
  'IIA recognized IAEP program school',
  'online MBA',
  'focus in finance',
  'international finance',
  'capital markets',
  'risk management',
  'commercial banking',
  'real estate',
  'investment services',
  'corporate posts',
  'Master of Science in Finance',
  'leader in finance',
  'strategic financial management',
  'financial analytics',
  'business goals',
  'financial industry',
  'greater responsibilities',
  'accounting role',
  'CPA credential',
  'high-quality educational experience',
  'securities analysis',
  'portfolio management',
  'data analysis',
  'financial modeling',
  'MA in Economics',
  'PhD',
  'high-level government',
  'NGO',
  'private-sector careers',
  'microeconomics',
  'macroeconomics',
  'econometrics',
  'quantitative concepts',
  'customizable program',
  'Master of Business Administration',
  'emphasis in Finance',
  'global economy',
  'organizational decision making',
  'corporate financial management',
  'investments',
  'corporate solvency',
  'profitability',
  'efficiency',
  'Associate of Arts with a concentration in Business Fundamentals',
  'fundamental business principles',
  'Associate of Arts degree in Business Administration',
  'basic business administration skills',
  'computer skills',
  'software applications',
  'business administration methods',
  'management skills',
  'Associate of Science in Business Administration',
  'general education',
  'elective courses',
  'faith-based liberal arts education',
  'business administration foundation courses',
  'online associate degree in business administration',
  'foundational knowledge',
  'accounting',
  'business law',
  'human resource management',
  'marketing',
  'Associate of Applied Science in Business Administration',
  'career opportunities',
  'accounting',
  'microcomputer skills',
  'managerial techniques',
  'decision-making',
  'problem-solving skills',
  'entrepreneurship',
  'event planning',
  'sales',
  'retail management',
  'ACBSP accredited',
  'associate of arts in Business Administration',
  'variety of careers',
  '2-year Business Administration Associate Degree',
  'fast-track program',
  'basic business skills',
  'employability',
  'professional profile',
  'Bachelor in Business Administration (BBA) degree',
  'Associate of Arts degree in Health Services Administration',
  'basic health services administration skills',
  'computer skills',
  'software applications',
  'healthcare business environment',
  'business law',
  'management and marketing principles',
  'medical anatomy',
  'physiology',
  'terminology',
  'front office management',
  'online A.S. in emergency medical services',
  'foundational aspects',
  'EMS',
  'academic groundwork',
  'paramedicine',
  'clinical skills',
  'EMS operational practices',
  'legal issues',
  'Associate Degree in Occupational Health and Safety (AOHS)',
  'job-essential aspects',
  'occupational health and safety',
  'further undergraduate study',
  'OHS career',
  'accredited by the Province of New Brunswick',
  'Board of Canadian Registered Safety Professionals (BCRSP)',
  'Master of Education degree',
  'Special Education',
  'characteristics and needs',
  'individuals qualifying for services',
  'IDEA/IDEIA',
  'Autism Spectrum Disorders (ASD)',
  'growing demand',
  'special education services',
  'higher graduation standards',
  "master's degree in autism spectrum disorders",
  'licensed special education teachers',
  "educator's responsibility",
  'online MSEd in Special Education',
  'practical experience',
  'latest breakthroughs',
  'students with special needs',
  "special education master's",
  'graduate certificate programs',
  'Autism Spectrum Disorder',
  'Applied Behavioral Analysis',
  'M.Ed. in Special Education',
  'unique learning abilities',
  'teaching methods',
  'ethical and legal considerations',
  'behavior modification',
  'cultural diversity',
  'responsive teaching',
  '100% of graduates hold teaching positions',
  'Master of Arts in Special Education',
  'meaningful learning experiences',
  'exceptional students',
  'design and implement curricula',
  'collaborate with families',
  'cultivate learning',
  'nationwide shortage',
  'special education educators',
  'instruct K-12 students',
  'interagency collaboration',
  'trends related to educating exceptional students',
  "Master's in Teaching degree",
  'special education credential',
  'teach in California',
  'moderate to severe disabilities',
  'fast-track pathway',
  'California Commission on Teacher Credentialing (CTC)',
  'Teacher Performance Expectations',
  'Free credential test preparation',
  "online master's of education (MEd)",
  'early childhood special education',
  'Master of Arts in Education/Special Education',
  'teacher licensure',
  'student teaching',
  'pedagogical skills',
  'effective special education educators',
  'Master of Public Health',
  'two-year',
  '100 percent online degree',
  'public health practitioner',
  'curriculum shaped by public health experts',
  'in-depth fieldwork',
  'impact the health of your community',
  'education that crosses geographical and cultural borders',
  'online Master of Public Health',
  'population health leadership and management',
  'expert faculty',
  'create real change',
  'CEPH-accredited online Master of Public Health',
  'global health practitioner',
  'public health practice concentration',
  '200 practicum hours',
  'Certified in Public Health (CPH) examination',
  'online Master of Public Health (MPH) degree',
  'promote health of large populations',
  'create programs',
  'systems',
  'policies',
  'MS in Public Health (MPH)',
  'high-growth leadership roles',
  'career-focused specializations',
  'CHES and MCHES certifications',
  'complete in 18 months',
  'Bridge (Master of Science in Nursing with an Emphasis in Public Health)',
  "experienced RN's",
  'MSN public health degree',
  'public health analysis',
  'planning and implementation',
  'six-course program',
  'assess learning needs',
  'innovate prevention',
  'interpret statistics',
  'conduct research',
  'disseminate nursing-related information',
  'demand for public health professionals',
  'health care reform',
  'environmental health concerns',
  'disease prevention',
  'community health',
  'evaluation of health programs',
  'principles of epidemiology and biostatistics',
  'environmental public health concepts',
  'public health administration systems',
  'economic factors',
  'practicum and capstone project',
  'web-based MPH@GW',
  'national and global health practice',
  'interdisciplinary teaching',
  'core competencies',
  'biostatistics and epidemiology',
  'cultural competency',
  'health communication',
  'implementation and evaluation methods',
  'public health biology',
  'systems thinking',
  'part-time or full-time',
  'control disease outbreaks',
  'develop wellness programs',
  'policy change',
  'Master of Science in Public Health',
  '36 credit program',
  'scientific basis of public health',
  'health and wellness trends',
  'national and global health policy',
  'ASPPH competencies',
  'WHO core functions',
  'complete in 15 months',
  'Master of Public Health',
  'leadership and managerial positions',
  'private organizations',
  'professional skills',
  'public health principles',
  "UNC's Gillings School",
  'No. 1-ranked public school of public health',
  'online Master of Public Health',
  'MPH@UNC',
  'earn your MPH in as few as 24 months',
  'part- and full-time options',
  'GRE',
  'GMAT or MCAT required',
  'Doctor of Business Administration in Leadership and Organizational Development',
  '100% online program',
  'professional administrators',
  'executives',
  'leaders',
  'practical application of research',
  'leadership challenges',
  'organizational development',
  'positive social impact',
  'real-world knowledge creation',
  'executive-level problem-solving',
  'thought-leadership',
  'applied research',
  'executive and/or administrative roles',
  'Ranked one of the top education schools',
  "Vanderbilt University's Peabody College",
  'Doctor of Education (Ed.D.) in leadership and learning in organizations',
  'experienced midcareer professionals',
  'practical skills',
  'systemic change',
  'organizational growth',
  'Doctor of Business Administration Degree',
  'experienced business professionals',
  'academia',
  'business/management theories',
  'global environment',
  'Doctorate of Marriage and Family Therapy (DMFT)',
  'Systemic Organizational Leadership',
  'critical thinking',
  'research skills',
  'practical application',
  'culturally sensitive',
  'leadership role',
  'non-clinical specialization',
  'practicum and internship',
  'systemic leadership',
  'Doctor of Management in Organizational Leadership',
  "professional master's degree",
  'personal readiness',
  'leadership literature',
  'current organizational environments',
  'global environment',
  'advanced decision-making',
  'leadership skills',
  'lifelong learning',
  'ethical decision-making',
  'effective communication',
  'sustainability',
  'information technologies',
  'Marketing',
  'Global Management',
  'Global Business',
  'Doctor of Business Administration program',
  'self-design option',
  'multidisciplinary',
  '100% online program',
  'professional administrators',
  'executives',
  'leaders',
  'public and private industry',
  'specialization coursework',
  'positive social impact',
  'real-world knowledge creation',
  'executive-level problem-solving',
  'thought-leadership',
  'applied research',
  'online DBA in Business Intelligence',
  'higher-order thinking',
  'research skills',
  'applied research',
  'actionable research',
  'agility',
  'data-driven decision-making',
  'real-world problems',
  'Doctor of Business Administration (DBA) degree program',
  "professional master's degree",
  'personal readiness',
  'leadership in management professions',
  'business administration literature',
  'current business environments',
  'Doctor of Philosophy in Educational Leadership',
  'reflective scholars',
  'improve schools',
  'lifelong learning',
  'ethical decision-making',
  'diversity',
  'program evaluation',
  'effective communication',
  'curriculum development',
  'instructional design',
  'course delivery',
  'online learning management systems',
  'instructional design methodologies',
  'educational media',
  'Doctor of Education (EdD)',
  'practitioner doctoral program',
  'educational leadership',
  'administration',
  'innovative curriculum',
  'transformational leadership',
  'Leadership Foundations',
  'Organizational Dynamics and Change',
  'Strategic Planning',
  'executive-level skill set',
  'educational institutions',
  'online doctorate of education (EdD)',
  'educational leadership',
  'Doctor of Education in Educational Leadership (Ed.D.)',
  'transformational leaders',
  'strategically manage',
  'lead complex educational organizations',
  'analytical thinking',
  'critical thinking',
  'innovative thinking',
  'applied research',
  'educational environments',
  'Associate of Science (A.S.) in Healthcare Administration',
  'general education',
  'healthcare administration and management',
  'healthcare terminology',
  'healthcare delivery systems',
  'role of spirituality and ethics',
  'healthcare human resources',
  'solid foundational understanding',
  'health care environment',
  'entry-level administrative positions',
  'health care management',
  'health care operations and policy',
  'privacy and conflict',
  'health services administrator',
  'department administrative assistant',
  'administrative clerk',
  'operations assistant',
  'Associate of Science in health information science/health care administration',
  'entry-level administrative positions',
  'managing situations',
  'health care facilities',
  'business principles',
  'ethical implications',
  'health care administrative responsibilities',
  'improve efficiencies and quality',
  'Associate of Arts degree in Health Services Administration',
  'basic health services administration skills',
  'business law',
  'management and marketing principles',
  'medical anatomy',
  'physiology and terminology',
  'front office management',
  'Master of Education degree',
  'Early Childhood Education',
  'assess educational potential',
  'create instructional programs',
  'coordinate learning activities',
  'manage early childhood classrooms',
  'MAE',
  'early childhood education programs',
  'fiscal planning',
  'leadership skills',
  'innovative curricula',
  'evaluate programs',
  'NAEYC standards',
  'program management',
  "master's degree in early childhood education leadership",
  '100% online',
  'flexible and accelerated classes',
  'advanced early childhood education leadership',
  'opportunities in and out of the classroom',
  "online master's degree",
  'design',
  'implement and evaluate educational services',
  'children from birth through age 8',
  'Master of Education in Early Childhood Education',
  'knowledge and expertise',
  'early childhood development and teaching',
  'NAEYC standards',
  'instructional strategies',
  'teaching methodologies',
  'assessment techniques',
  'theories of early childhood growth',
  'family and cultural diversity',
  'Associate of Arts degree in Paralegal Studies',
  'support attorneys',
  'transactional and litigation fields',
  'legal research',
  'document drafting',
  'case management',
  'evidence gathering',
  'litigation procedure',
  'trial assistance',
  'dispute resolution',
  'real estate documents',
  'wills',
  'trusts',
  'contracts',
  'corporate matters',
  'law office investigations',
  'Master of Education in Educational Administration',
  'initial teacher licensure',
  'educational administrators',
  'administrative certificate',
  'K-12 setting',
  'regionally accredited program',
  'school leadership',
  'administrative foundations',
  'organizational theory',
  'K-12 legal issues',
  'public school finance',
  'curriculum development',
  'instructional leadership',
  'educational administration',
  'principal-ship',
  'school improvement',
  'observational and practice-based experiences',
  'administrative internship',
  'certified teaching experience',
  'informed and effective educational administrators',
  'Master of Arts in Education/Administration and Supervision',
  'principal licensure',
  'standards-based program',
  'instructional leadership',
  'organizational management',
  'technology management',
  'data-driven decision-making',
  'administrative internship',
  'school administration and supervision',
  'Master of Education degree',
  'specialization in Instructional Leadership',
  'analyze instructional capacity',
  'improve student achievement',
  'teacher leadership skills',
  'assessment and improvement strategies',
  'K-12 educational settings',
  'Master of Science in Higher Education Administration',
  'analytical skills',
  'leading within an institution of higher education',
  'empirical research',
  'data-centric decision-making',
  'analytical problem-solving',
  'effectiveness of initiatives',
  'data-based conclusions',
  'real world problems',
  'institutional research',
  'strategic planning',
  'institutions of higher education',
  'comprehensive student services program',
  'measure student learning',
  'evaluate academic programs',
  'accreditation procedures',
  'standards for online programs',
  'CTC-approved Preliminary Administrative Services Credential',
  'MAE in Educational Administration',
  'online coursework',
  'theory with practical situations',
  'problem solving',
  'conflict resolution',
  'diverse individuals',
  'Master of Education in Educational Administration',
  'initial teacher licensure',
  'educational administrators',
  'administrative certificate',
  'K-12 setting',
  'regionally accredited program',
  'school leadership',
  'administrative foundations',
  'organizational theory',
  'K-12 legal issues',
  'public school finance',
  'curriculum development',
  'instructional leadership',
  'educational administration',
  'principal-ship',
  'school improvement',
  'observational and practice-based experiences',
  'administrative internship',
  'certified teaching experience',
  'informed and effective educational administrators',
  '39-hour',
  'no application fee',
];

export default KEYWORDS;
